export const USER_SUMMARY_CTO_REQUEST_ID = 'c064a288-7080-4a8c-86d8-7063f6429cba';
export const USER_SUMMARY_CTO_TRACKID = '1994aab4-f115-4608-9986-48cbbb070854';
export const USER_REMOVE_CTO_REQUEST_ID = 'db44711f-d1f8-4055-9a02-32313374fa15';
export const USER_REMOVE_CTO_TRACKID = '41fbe0be-0a07-4484-bf02-42ba5c3ec196';
export const APPLICATION_JSON = 'application/json';
export const EDIT_PERMISSION_STRING = 'userSummary.edituser';
export const REMOVE_PERMISSION_STRING = 'userSummary.removeuser';
export const AUA_PERMISSION_STRING = 'userSummary.assignunassign';
